import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/design-system/foundations")({
  component: () => <Outlet />,
});
